import React from "react";
import "./popup-footer.css";

function PopupFooter(props) {
  var default_color = 'rgb(255, 103, 76, 1)';
  const isLoading = props.isLoading === true;
  const showSpinner = isLoading || props.showSpinner === true;
  const isDisabled = props.disabled === true || isLoading;
  const ariaBusy = props.ariaBusy === true || isLoading || props.showSpinner === true;

  return (
    <div style={{ background: props.color || default_color }} className="item-popup-footer">
      <button className="item-popup-btn btn-exit" type="button" onClick={props.onClick} disabled={isDisabled} aria-busy={ariaBusy}>
        <span className="item-popup-btn-inner">
          {showSpinner && <span className="popup-footer-spinner" aria-hidden="true" />}
          <p className="item-popup-font">{props.title}</p>
        </span>
      </button>
    </div>
  );
}
export default PopupFooter;